import React from 'react';
import { isSafari, isIOS } from 'react-device-detect';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import PageLines from '../@common/PageLines';
import BaseInput from '../@common/BaseInput';
import GroupedPageLines from '../@common/GroupedPageLines';
import NameAndDateLines from '../@common/NameAndDateLines';
import ReasonRow from './reasonRow';
import MyOpinionTitle from './title';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

const MyOpinionPrekTo1 = ({ onChange, isCursive, reasons, valueMap, printRef }) => {
  const bookFont = isCursive ? 'Cursive-Book' : 'Print-Wide-Book';
  const fontSize = 61;
  const marginTop = '-34px';
  const fontSizeInput = 60;
  const marginTopInputText = isIOS ? '-43.5px' : '-44px';
  const marginInputLines = reasons ? '30px 25px 0px !important' : '4px 25px 0px !important';
  const marginPageLines = '20px';
  const reasonsMarginTop = reasons ? '120px' : '85px';

  const classes = useStyles({ marginTopInputText, marginInputLines, isSafari });
  return (
    <LandscapePaperLayout isWide printRef={printRef}>
      <MyOpinionTitle reasons={reasons} />
      <Box>
        <NameAndDateLines
          isCursive={isCursive}
          fontFamily={bookFont}
          top={-60}
          isWide
          width={1000}
        />
      </Box>
      <PageLines width={1000} className={classes.pageLine} isWide paddingTop={30}>
        <BaseInput
          // eslint-disable-next-line
          onChange={({ target }) => onChange({ [1]: target.value })}
          showBackground={true}
          fontFamily={bookFont}
          color="#000"
          placeholder={t('enterTopic')}
          className={classes.input}
          fontSize={fontSizeInput}
          maxLength={45}
          value={valueMap[1]}
        />
      </PageLines>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '40px'
        }}
      >
        <>
          <GroupedPageLines
            top={8}
            width={1000}
            fontSize={fontSize}
            color="black"
            marginLeftText={3}
            marginTopText={marginTop}
            marginPageLines="10px 25px 0px"
            fontFamily={bookFont}
            isWide
            paddingTop={30}
          >
            {reasons ? t('opinion') : t('myOpinion')}:
          </GroupedPageLines>
          <GroupedPageLines
            top={reasons ? 50 : 40}
            width={1000}
            marginPageLines="40px 25px 0px"
            isWide
            paddingTop={30}
          />
        </>

        <Box style={{ marginTop: reasonsMarginTop }}>
          <ReasonRow
            reasons={reasons}
            fontSize={fontSize}
            fontFamily={bookFont}
            marginTop={marginTop}
            number={1}
          />
          {reasons ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                top: 162,
                margin: '10px 0 0',
                flexDirection: 'column',
                padding: '18px'
              }}
            >
              <ReasonRow
                reasons={reasons}
                fontSize={fontSize}
                fontFamily={bookFont}
                marginTop={30}
                noText
                lineWidth={960}
                number={2}
                marginTopLine={-15}
              />
            </div>
          ) : (
            <>
              <GroupedPageLines
                top={60}
                width={1005}
                marginPageLines={marginPageLines}
                isWide
                paddingTop={30}
              />
              <GroupedPageLines
                top={110}
                width={1005}
                marginPageLines={marginPageLines}
                isWide
                paddingTop={30}
              />
            </>
          )}
        </Box>
      </Box>
    </LandscapePaperLayout>
  );
};

const useStyles = makeStyles(() => ({
  pageLine: ({ marginInputLines }: any) => ({
    alignSelf: 'center !important',
    margin: marginInputLines,
    position: 'relative',
    top: '-10px !important',
    left: '0px !important'
  }),
  pageLineText: {
    justifyContent: 'space-between !important',
    width: '514px !important',
    marginLeft: '20px !important',
    fontSize: '30px !important',
    marginTop: '-26px !important'
  },
  input: ({ marginTopInputText }: any) => ({
    width: '1000px !important',
    marginLeft: '0px !important',
    paddingLeft: '10px',
    marginTop: `${marginTopInputText} !important`,
    color: 'black'
  })
}));
export default MyOpinionPrekTo1;
